/**
 * getController / setControlledTimout
 *
 * Usage:
 *

import { useEffect } from 'react';

export function MyComponent() {
  useEffect(() => {
    const { signal, abort } = getController();

    // set multiple timers or event listeners with the same signal
    setControlledTimeout(() => console.log('timeout 1'), 1000, signal);
    setControlledInterval(() => console.log('interval 2'), 2000, signal);
    document.addEventListener('resizeend', () => console.log('resize end'), { signal });

    // one signal to control them all
    return abort;
  }, []);
}

*/

export function getController() {
  const controller = new AbortController();
  const { signal } = controller;
  const abort = () => controller.abort(); // have to close over the controller
  return { controller, signal, abort };
}

export function setControlledTimeout(callback: VoidFunction, delay: number, signal: AbortSignal) {
  const timer = setTimeout(callback, delay);
  signal.addEventListener('abort', () => clearTimeout(timer));
  return timer;
}

export function setControlledInterval(
  callback: VoidFunction,
  interval: number,
  signal: AbortSignal,
) {
  const timer = setInterval(callback, interval);
  signal.addEventListener('abort', () => clearInterval(timer));
  return timer;
}
